import React, { Component } from 'react';
import { isLoggedIn, getLogin, getRole } from '../utils/AuthService';
import '../App.css';

class MainPage extends Component {

  render() {
  const logged = isLoggedIn();
  return (
    <div>
      {
        logged ? (
          <div style={{ textAlign: 'center', marginTop: 40 }}>
            <h3>Witaj, {getLogin()}</h3>
            <p style={{ color: '#666' }}>Rola: {getRole()}</p>
          </div>
        ) : (
          <div style={{ textAlign: 'center', marginTop: 60 }}>
            <h1>Zaloguj się</h1>
            <p style={{ marginTop: 20 }}>
              <a href="/login" className="btn btn-primary btn-lg">Przejdź do logowania</a>
            </p>
          </div>
        )
      }
    </div>
  );
}
}

export default MainPage;



// WEBPACK FOOTER //
// ./src/components/MainPage.js